import { render, staticRenderFns } from "./LoyaltyPrograms.vue?vue&type=template&id=100851bd"
import script from "./LoyaltyPrograms.vue?vue&type=script&lang=js"
export * from "./LoyaltyPrograms.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports